/* eslint-disable max-lines */
import { MANUAL_STRATEGY_TYPE, TARGET_IMPRESSION_SHARE } from '@domain/segments/segments-modal';

export const CAMPAIGNS_MOCK = {
    campaigns: {
        loadState: 'success',
        data: {
            consolidated_items: {
                cost: 1550.3,
                cost_projection: 1550.3,
                cost_last_seven_days_variation: 0.1,
                cpa_projection: 616.28,
                cpa_last_seven_days_variation: 0.08,
                roas_projection: 4.69,
                roas_last_seven_days_variation: 0.08,
                ctr: 0.01,
                cpm: 165106.32,
                clicks: 7052,
                cpc: 0.04,
                impressions: 214931,
                conversion_values: 37857.21,
                conversions: 277.89,
                cpa: 5.57882615423369,
                roas: 24.41928013932787,
                ticket_value: 136.23091870884164,
                quality_score: 0,
                cpv: 0,
                impressions_share: 0,
            },
            items: [
                {
                    campaign_id: '5454',
                    campaign_name: 'Cinema',
                    name: 'Cinema',
                    sublevel_id: null,
                    sublevel_name: null,
                    type: 'Search',
                    bid_strategy_type: 'Target CPA',
                    cpc: 0,
                    impressions: 0,
                    cpm: 0,
                    ctr: 0,
                    conversions: 0,
                    cost: 0,
                    cpa: 0,
                    roas: 0,
                    ticket_value: 0,
                    cpv: 0,
                    clicks: 0,
                    platform: 'google_ads',
                    status: 'removed',
                    quality_score: 0,
                    conversion_values: 0,
                    tags: [
                        {
                            group_name: 'Campaign Type',
                            group_slug: 'campaign_type',
                            tag: {
                                value: 'Search',
                                label: 'Search',
                            },
                            group_id: null,
                        },
                    ],
                    cost_projection: 0,
                    cpa_projection: 0,
                    roas_projection: 0,
                    cost_last_seven_days_variation: 0,
                    cpa_last_seven_days_variation: 0,
                    roas_last_seven_days_variation: 0,
                },
                {
                    campaign_id: '546521',
                    campaign_name: 'pareto.mock.Adbot',
                    name: 'pareto.mock.Adbot',
                    sublevel_id: null,
                    sublevel_name: null,
                    type: 'Search',
                    bid_strategy_type: 'Target CPA',
                    cpc: 0,
                    impressions: 0,
                    cpm: 0,
                    ctr: 0,
                    conversions: 0,
                    cost: 0,
                    cpa: 0,
                    roas: 0,
                    ticket_value: 0,
                    cpv: 0,
                    clicks: 0,
                    platform: 'google_ads',
                    status: 'removed',
                    quality_score: 0,
                    conversion_values: 0,
                    tags: [
                        {
                            group_name: 'Campaign Type',
                            group_slug: 'campaign_type',
                            tag: {
                                value: 'Search',
                                label: 'Search',
                            },
                            group_id: null,
                        },
                    ],
                    cost_projection: 0,
                    cpa_projection: 0,
                    roas_projection: 0,
                    cost_last_seven_days_variation: 0,
                    cpa_last_seven_days_variation: 0,
                    roas_last_seven_days_variation: 0,
                },
                {
                    campaign_id: '84654612',
                    campaign_name: 'pareto.mock.Adbot',
                    name: 'pareto.mock.Adbot',
                    sublevel_id: null,
                    sublevel_name: null,
                    type: 'Search',
                    bid_strategy_type: 'Maximize Conversions',
                    cpc: 0,
                    impressions: 0,
                    cpm: 0,
                    ctr: 0,
                    conversions: 0,
                    cost: 0,
                    cpa: 0,
                    roas: 0,
                    ticket_value: 0,
                    cpv: 0,
                    clicks: 0,
                    platform: 'google_ads',
                    status: 'removed',
                    quality_score: 0,
                    conversion_values: 0,
                    tags: [
                        {
                            group_name: 'Campaign Type',
                            group_slug: 'campaign_type',
                            tag: {
                                value: 'Search',
                                label: 'Search',
                            },
                            group_id: null,
                        },
                    ],
                    cost_projection: 0,
                    cpa_projection: 0,
                    roas_projection: 0,
                    cost_last_seven_days_variation: 0,
                    cpa_last_seven_days_variation: 0,
                    roas_last_seven_days_variation: 0,
                },
                {
                    campaign_id: '889293791',
                    campaign_name: 'pareto.br #2',
                    name: 'pareto.br #2',
                    sublevel_id: null,
                    sublevel_name: null,
                    type: 'Display',
                    bid_strategy_type: 'Maximize Conversions',
                    cpc: 0,
                    impressions: 0,
                    cpm: 0,
                    ctr: 0,
                    conversions: 0,
                    cost: 0,
                    cpa: 0,
                    roas: 0,
                    ticket_value: 0,
                    cpv: 0,
                    clicks: 0,
                    platform: 'google_ads',
                    status: 'removed',
                    quality_score: 0,
                    conversion_values: 0,
                    tags: [
                        {
                            group_name: 'Campaign Type',
                            group_slug: 'campaign_type',
                            tag: {
                                value: 'Display',
                                label: 'Display',
                            },
                            group_id: null,
                        },
                    ],
                    cost_projection: 0,
                    cpa_projection: 0,
                    roas_projection: 0,
                    cost_last_seven_days_variation: 0,
                    cpa_last_seven_days_variation: 0,
                    roas_last_seven_days_variation: 0,
                },
                {
                    campaign_id: '8494612',
                    campaign_name: 'pareto.br #3',
                    name: 'pareto.br #3',
                    sublevel_id: null,
                    sublevel_name: null,
                    type: 'Display',
                    bid_strategy_type: 'Target CPA',
                    cpc: 0,
                    impressions: 0,
                    cpm: 0,
                    ctr: 0,
                    conversions: 0,
                    cost: 0,
                    cpa: 0,
                    roas: 0,
                    ticket_value: 0,
                    cpv: 0,
                    clicks: 0,
                    platform: 'google_ads',
                    status: 'removed',
                    quality_score: 0,
                    conversion_values: 0,
                    tags: [
                        {
                            group_name: 'Campaign Type',
                            group_slug: 'campaign_type',
                            tag: {
                                value: 'Display',
                                label: 'Display',
                            },
                            group_id: null,
                        },
                    ],
                    cost_projection: 0,
                    cpa_projection: 0,
                    roas_projection: 0,
                    cost_last_seven_days_variation: 0,
                    cpa_last_seven_days_variation: 0,
                    roas_last_seven_days_variation: 0,
                },
                {
                    campaign_id: '454546',
                    campaign_name: 'teste',
                    name: 'teste',
                    sublevel_id: null,
                    sublevel_name: null,
                    type: 'Display',
                    bid_strategy_type: 'cpv',
                    cpc: 0,
                    impressions: 0,
                    cpm: 0,
                    ctr: 0,
                    conversions: 0,
                    cost: 0,
                    cpa: 0,
                    roas: 0,
                    ticket_value: 0,
                    cpv: 0,
                    clicks: 0,
                    platform: 'google_ads',
                    status: 'removed',
                    quality_score: 0,
                    conversion_values: 0,
                    tags: [
                        {
                            group_name: 'Campaign Type',
                            group_slug: 'campaign_type',
                            tag: {
                                value: 'Display',
                                label: 'Display',
                            },
                            group_id: null,
                        },
                    ],
                    cost_projection: 0,
                    cpa_projection: 0,
                    roas_projection: 0,
                    cost_last_seven_days_variation: 0,
                    cpa_last_seven_days_variation: 0,
                    roas_last_seven_days_variation: 0,
                },
                {
                    campaign_id: '4545',
                    campaign_name: 'teste',
                    name: 'teste',
                    sublevel_id: null,
                    sublevel_name: null,
                    type: 'Display',
                    bid_strategy_type: 'cpv',
                    cpc: 0,
                    impressions: 0,
                    cpm: 0,
                    ctr: 0,
                    conversions: 0,
                    cost: 0,
                    cpa: 0,
                    roas: 0,
                    ticket_value: 0,
                    cpv: 0,
                    clicks: 0,
                    platform: 'google_ads',
                    status: 'removed',
                    quality_score: 0,
                    conversion_values: 0,
                    tags: [
                        {
                            group_name: 'Campaign Type',
                            group_slug: 'campaign_type',
                            tag: {
                                value: 'Display',
                                label: 'Display',
                            },
                            group_id: null,
                        },
                    ],
                    cost_projection: 0,
                    cpa_projection: 0,
                    roas_projection: 0,
                    cost_last_seven_days_variation: 0,
                    cpa_last_seven_days_variation: 0,
                    roas_last_seven_days_variation: 0,
                },
                {
                    campaign_id: '45455',
                    campaign_name: 'teste',
                    name: 'teste',
                    sublevel_id: null,
                    sublevel_name: null,
                    type: 'Display',
                    bid_strategy_type: '--',
                    cpc: 0,
                    impressions: 0,
                    cpm: 0,
                    ctr: 0,
                    conversions: 0,
                    cost: 100,
                    cpa: 0,
                    roas: 0,
                    ticket_value: 0,
                    cpv: 0,
                    clicks: 0,
                    platform: 'google_ads',
                    status: 'removed',
                    quality_score: 0,
                    conversion_values: 0,
                    cost_projection: 0,
                    cpa_projection: 0,
                    roas_projection: 0,
                    cost_last_seven_days_variation: 0,
                    cpa_last_seven_days_variation: 0,
                    roas_last_seven_days_variation: 0,
                    tags: [
                        {
                            group_name: 'Campaign Type',
                            group_slug: 'campaign_type',
                            tag: {
                                value: 'Facebook',
                                label: 'Facebook',
                            },
                            group_id: null,
                        },
                    ],
                },
                {
                    campaign_id: '4545555',
                    campaign_name: 'teste',
                    name: 'teste',
                    sublevel_id: null,
                    sublevel_name: null,
                    type: 'Display',
                    bid_strategy_type: '--',
                    cpc: 0,
                    impressions: 0,
                    cpm: 0,
                    ctr: 0,
                    conversions: 0,
                    cost: 50,
                    cpa: 0,
                    roas: 0,
                    ticket_value: 0,
                    cpv: 0,
                    clicks: 0,
                    platform: 'google_ads',
                    status: 'removed',
                    quality_score: 0,
                    conversion_values: 0,
                    cost_projection: 0,
                    cpa_projection: 0,
                    roas_projection: 0,
                    cost_last_seven_days_variation: 0,
                    cpa_last_seven_days_variation: 0,
                    roas_last_seven_days_variation: 0,
                    tags: [
                        {
                            group_name: 'Campaign Type',
                            group_slug: 'campaign_type',
                            tag: {
                                value: 'Display',
                                label: 'Display',
                            },
                            group_id: null,
                        },
                    ],
                },
                {
                    campaign_id: '4545556',
                    campaign_name: 'teste',
                    name: 'teste',
                    sublevel_id: null,
                    sublevel_name: null,
                    type: 'Display',
                    bid_strategy_type: 'Maximize Conversions',
                    cpc: 0,
                    impressions: 0,
                    cpm: 0,
                    ctr: 0,
                    conversions: 0,
                    cost: 25,
                    cpa: 0,
                    roas: 0,
                    ticket_value: 0,
                    cpv: 0,
                    clicks: 0,
                    platform: 'google_ads',
                    status: 'removed',
                    quality_score: 0,
                    conversion_values: 0,
                    cost_projection: 0,
                    cpa_projection: 0,
                    roas_projection: 0,
                    cost_last_seven_days_variation: 0,
                    cpa_last_seven_days_variation: 0,
                    roas_last_seven_days_variation: 0,
                    tags: [
                        {
                            group_name: 'Campaign Type',
                            group_slug: 'campaign_type',
                            tag: {
                                value: 'Express',
                                label: 'Express',
                            },
                            group_id: null,
                        },
                    ],
                },
            ],
        },
        error: null,
    },
};

export const filteredCampaigns = [
    {
        campaign_id: '454546',
        campaign_name: 'teste',
        name: 'teste',
        sublevel_id: null,
        sublevel_name: null,
        type: 'Display',
        bid_strategy_type: 'cpv',
        cpc: 0,
        impressions: 0,
        cpm: 0,
        ctr: 0,
        conversions: 0,
        cost: 0,
        cpa: 0,
        roas: 0,
        ticket_value: 0,
        cpv: 0,
        clicks: 0,
        platform: 'google_ads',
        status: 'removed',
        quality_score: 0,
        conversion_values: 0,
        tags: [
            {
                group_name: 'Campaign Type',
                group_slug: 'campaign_type',
                tag: {
                    value: 'Display',
                    label: 'Display',
                },
                group_id: null,
            },
        ],
        cost_projection: 0,
        cpa_projection: 0,
        roas_projection: 0,
        cost_last_seven_days_variation: 0,
        cpa_last_seven_days_variation: 0,
        roas_last_seven_days_variation: 0,
    },
    {
        campaign_id: '4545',
        campaign_name: 'teste',
        name: 'teste',
        sublevel_id: null,
        sublevel_name: null,
        type: 'Display',
        bid_strategy_type: 'cpv',
        cpc: 0,
        impressions: 0,
        cpm: 0,
        ctr: 0,
        conversions: 0,
        cost: 0,
        cpa: 0,
        roas: 0,
        ticket_value: 0,
        cpv: 0,
        clicks: 0,
        platform: 'google_ads',
        status: 'removed',
        quality_score: 0,
        conversion_values: 0,
        tags: [
            {
                group_name: 'Campaign Type',
                group_slug: 'campaign_type',
                tag: {
                    value: 'Display',
                    label: 'Display',
                },
                group_id: null,
            },
        ],
        cost_projection: 0,
        cpa_projection: 0,
        roas_projection: 0,
        cost_last_seven_days_variation: 0,
        cpa_last_seven_days_variation: 0,
        roas_last_seven_days_variation: 0,
    },
    {
        campaign_id: '45455',
        campaign_name: 'teste',
        name: 'teste',
        sublevel_id: null,
        sublevel_name: null,
        type: 'Display',
        bid_strategy_type: '--',
        cpc: 0,
        impressions: 0,
        cpm: 0,
        ctr: 0,
        conversions: 0,
        cost: 100,
        cpa: 0,
        roas: 0,
        ticket_value: 0,
        cpv: 0,
        clicks: 0,
        platform: 'google_ads',
        status: 'removed',
        quality_score: 0,
        conversion_values: 0,
        cost_projection: 0,
        cpa_projection: 0,
        roas_projection: 0,
        cost_last_seven_days_variation: 0,
        cpa_last_seven_days_variation: 0,
        roas_last_seven_days_variation: 0,
        tags: [
            {
                group_name: 'Campaign Type',
                group_slug: 'campaign_type',
                tag: {
                    value: 'Facebook',
                    label: 'Facebook',
                },
                group_id: null,
            },
        ],
    },
    {
        campaign_id: '4545555',
        campaign_name: 'teste',
        name: 'teste',
        sublevel_id: null,
        sublevel_name: null,
        type: 'Display',
        bid_strategy_type: '--',
        cpc: 0,
        impressions: 0,
        cpm: 0,
        ctr: 0,
        conversions: 0,
        cost: 50,
        cpa: 0,
        roas: 0,
        ticket_value: 0,
        cpv: 0,
        clicks: 0,
        platform: 'google_ads',
        status: 'removed',
        quality_score: 0,
        conversion_values: 0,
        cost_projection: 0,
        cpa_projection: 0,
        roas_projection: 0,
        cost_last_seven_days_variation: 0,
        cpa_last_seven_days_variation: 0,
        roas_last_seven_days_variation: 0,
        tags: [
            {
                group_name: 'Campaign Type',
                group_slug: 'campaign_type',
                tag: {
                    value: 'Display',
                    label: 'Display',
                },
                group_id: null,
            },
        ],
    },
    {
        campaign_id: '4545556',
        campaign_name: 'teste',
        name: 'teste',
        sublevel_id: null,
        sublevel_name: null,
        type: 'Display',
        bid_strategy_type: 'Maximize Conversions',
        cpc: 0,
        impressions: 0,
        cpm: 0,
        ctr: 0,
        conversions: 0,
        cost: 25,
        cpa: 0,
        roas: 0,
        ticket_value: 0,
        cpv: 0,
        clicks: 0,
        platform: 'google_ads',
        status: 'removed',
        quality_score: 0,
        conversion_values: 0,
        cost_projection: 0,
        cpa_projection: 0,
        roas_projection: 0,
        cost_last_seven_days_variation: 0,
        cpa_last_seven_days_variation: 0,
        roas_last_seven_days_variation: 0,
        tags: [
            {
                group_name: 'Campaign Type',
                group_slug: 'campaign_type',
                tag: {
                    value: 'Express',
                    label: 'Express',
                },
                group_id: null,
            },
        ],
    },
];

export const CAMPAIGNS_MOCK_WITH_FACEBOOK = {
    ...CAMPAIGNS_MOCK.campaigns.data.consolidated_items,
    items: [
        ...CAMPAIGNS_MOCK.campaigns.data.items,
        {
            account_currency: 'BRL',
            account_id: 6,
            account_name: 'Pareto Group',
            bid_strategy_type: 'LOWEST_COST_WITHOUT_CAP',
            campaign_id: '23846447891090282',
            level: 'campaign',
            link_click: '17110',
            name: 'pareto.in.fba.traff (broad)',
            objective: 'LINK_CLICKS',
            platform: 'facebook_ads',
            type: 'Facebook Ads',
            status: 'paused',
        },
    ],
};

export const EXPECTED_BID_STRATEGIES_FOR_FACEBOOK = [
    'Target CPA',
    'Target CPA',
    'Maximize Conversions',
    'Maximize Conversions',
    'Target CPA',
    MANUAL_STRATEGY_TYPE.cpv,
    MANUAL_STRATEGY_TYPE.cpv,
    TARGET_IMPRESSION_SHARE,
    TARGET_IMPRESSION_SHARE,
    'Maximize Conversions',
    'Link Clicks',
];

export const EXPECTED_BID_STRATEGIES_FOR_GOOGLE = [
    'Target CPA',
    'Target CPA',
    'Maximize Conversions',
    'Maximize Conversions',
    'Target CPA',
    MANUAL_STRATEGY_TYPE.cpv,
    MANUAL_STRATEGY_TYPE.cpv,
    TARGET_IMPRESSION_SHARE,
    TARGET_IMPRESSION_SHARE,
    'Maximize Conversions',
];

export const campaignsFacebookMock = [
    {
        account_id: 3,
        account_name: 'Pareto Group',
        campaign_id: '5',
        level: 'campaign',
        platform: 'facebook_ads',
        type: 'Facebook Ads',
    },
    {
        platform: 'facebook_ads',
        status: 'enabled',
        sublevel_id: '12',
        sublevel_name: 'pareto.p{admin.pages(home180d))',
        tags: [
            {
                group_id: 415,
                group_name: 'Budget Manager Automation',
                group_slug: 'budget-manager-automation-615-29',
                tag: 'untagged',
            },
            {
                group_id: null,
                group_name: 'Campaign Type',
                group_slug: 'campaign_type',
                tag: {
                    label: 'Facebook',
                    value: 'Facebook',
                },
            },
            {
                group_id: 1366,
                group_name: 'Teste daniel',
                group_slug: 'teste-daniel-615-29',
                tag: {},
            },
        ],
    },
];

export const groupSlugMock = 'teste-daniel-615-29';

export const expectedResultFromDeleteTagGroupBySlug = [
    {
        account_id: 3,
        account_name: 'Pareto Group',
        campaign_id: '5',
        level: 'campaign',
        platform: 'facebook_ads',
        type: 'Facebook Ads',
    },
    {
        platform: 'facebook_ads',
        status: 'enabled',
        sublevel_id: '12',
        sublevel_name: 'pareto.p{admin.pages(home180d))',
        tags: [
            {
                group_id: 415,
                group_name: 'Budget Manager Automation',
                group_slug: 'budget-manager-automation-615-29',
                tag: 'untagged',
            },
            {
                group_id: null,
                group_name: 'Campaign Type',
                group_slug: 'campaign_type',
                tag: {
                    label: 'Facebook',
                    value: 'Facebook',
                },
            },
        ],
    },
];
